import { css as i } from "styled-components";
const r = {
  base: ({ theme: o }) => /* @__PURE__ */ i([
    "width:0.1rem;height:0.1rem;color:",
    ";position:absolute;top:-1rem;overflow:hidden;transition:height 0.2s;text-decoration:none;&:focus{height:auto;width:65%;overflow:hidden;margin:0;text-align:center;top:4.5rem;left:0;display:block;background-color:",
    ";color:",
    ";padding:1.4rem;box-shadow:0 0 0.2rem 0.1rem ",
    ";font-size:1.9rem;line-height:2.1rem;border-bottom:0.1rem solid ",
    ";font-weight:500;}",
    "{&:focus{width:50%;font-size:2.2rem;line-height:2.4rem;}}"
  ], o.componentColors.skipLink.background, o.componentColors.skipLink.background, o.componentColors.skipLink.text, o.componentColors.skipLink.box, o.componentColors.skipLink.border, o.breakpoints.mq && o.breakpoints.mq.tabletMin)
};
export {
  r as default
};
